<template>
	<input type="text" @focus="onFocus" @blur="onBlur" @keydown="onKeyDown" @keyup.stop="onKeyUp" />
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import $ from 'jquery'
import 'autonumeric'
import Numeral from 'numeral'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'numberInput',
	//=========================================================================
	// свойства
	//=========================================================================
	props: [
		// значение модели
		'value',
		// тип поля
		'type',
		// нужно ли отслеживать изменения модели родителем
		'needReact',
		// crud
		'crud'
	],
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			// числовое значение поля
			numberValue: 0,
			// jQuery-объект поля
			$input: null
		}
	},
	//=========================================================================
	// при создании компонента и монтировании его в DOM доступен this.$el
	//=========================================================================
	mounted() {
		// получим jQuery-объект
		this.$input = $(this.$el)

		// инициализируем плагин
		// целое число
		if (this.type === 'integer')
			this.$input.autoNumeric('init', { aSep: '', mDec: 0 })
		// денежка
		else if (this.type === 'money')
		{
			if (this.crud === 'paymentauto')
			{
				this.$input.autoNumeric('init', { aSep: ' ', aDec: '.', aPad: false, mDec: 2 })
			}
			else
			{
				if (this.$store.state.user_type === 'admin')
					this.$input.autoNumeric('init', { aSep: ' ', aDec: '.', mDec: 4 })
				else
					this.$input.autoNumeric('init', { aSep: ' ', aDec: '.' })
			}
		}
		// другие вещественные числа
		else this.$input.autoNumeric('init', { aSep: ' ', aDec: '.' })

		// инициализируем числовое значение
		this.numberValue = Numeral(this.clearFormatValue(this.value)).value()
		// проверка значения
		if (isNaN(this.numberValue)) this.numberValue = null
		if (this.numberValue !== null && this.numberValue !== undefined)
		{
			// установим значение
			this.$input.autoNumeric('set', this.numberValue)
		}

		EventBus.$on('w5-set-money-field-value', this.setValueByEvent)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		EventBus.$off('w5-set-money-field-value', this.setValueByEvent)
	},
	//=========================================================================
	// методы
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// событие: установить значение компонента
		//---------------------------------------------------------------------
		setValueByEvent(data) {
			// проверка данных
			if (!data || typeof data !== 'object' || !data['type'] || !data['name'] || !('value' in data)) return
			// если это не нам
			if (data['name'] !== this.$el.name || data['type'] !== this.type) return
			// меняем текущее значение
			this.numberValue = data['value']
			// установим значение
			if (this.numberValue !== null && this.numberValue !== undefined)
			{
				this.$input.autoNumeric('set', this.numberValue)
			}
			else
			{
				// нужно почистить значение
				this.$input.autoNumeric('set', '')
			}
			// сообщим родителю о смене значения
			this.$emit('input', this.numberValue)
			// попросим анимацию если есть соответствующий флаг
			if (data.animation)
				this.$emit('animation')
		},
		//---------------------------------------------------------------------
		// предварительная чистка модели
		//---------------------------------------------------------------------
		clearFormatValue(value) {
			// получаем значение
			let _val = ''
			if (value !== undefined && value !== null) _val = String(value)
			else _val = String(this.$input.autoNumeric('get'))
			// уберем все пробелы
			let _str = _val.replace(/ /g, '')
			// нормализуем разделитель дроби
			_val = _str.replace(',', '.')
			// вернем результат
			return _val
		},
		//---------------------------------------------------------------------
		// событие: фокус
		//---------------------------------------------------------------------
		onFocus() {
			// обновляем модель
			this.numberValue = Numeral(this.clearFormatValue()).value()
			// проверка значения
			if (isNaN(this.numberValue)) this.numberValue = null
			if (this.numberValue !== null && this.numberValue !== undefined)
			{
				// установим значение
				this.$input.autoNumeric('set', this.numberValue)
			}

			// выделяем весь текст поля
			setTimeout(() => this.$input.select(), 100)

			// сообщаем родителю что получили фоксу
			this.$emit('focus')
		},
		//---------------------------------------------------------------------
		// событие: потеря фокуса
		//---------------------------------------------------------------------
		onBlur() {
			// обновляем модель
			this.numberValue = Numeral(this.clearFormatValue()).value()
			// проверка значения
			if (isNaN(this.numberValue)) this.numberValue = null
			if (this.numberValue !== null && this.numberValue !== undefined)
			{
				// установим значение
				this.$input.autoNumeric('set', this.numberValue)
			}

			// сообщим родителю о смене значения
			this.$emit('input', this.numberValue)
			// сообщаем родителю что потеряли фоксу
			this.$emit('blur')
		},
		//---------------------------------------------------------------------
		// событие: keydown
		//---------------------------------------------------------------------
		onKeyDown(e) {
			// если это был Enter - тоже сообщим родителю
			if (e.keyCode === 13 || e.which === 13) this.$emit('keydownEnter', e)
		},
		//---------------------------------------------------------------------
		// соыбтие: keyup
		//---------------------------------------------------------------------
		onKeyUp(e) {
			// обновляем модель
			this.numberValue = Numeral(this.clearFormatValue()).value()
			// проверка значения
			if (isNaN(this.numberValue)) this.numberValue = null
			// сообщим родителю
			this.$emit('input', this.numberValue)
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатели
	//=========================================================================
	watch: {
		// изменение модели родителем
		'value': function(value) {
			if (this.needReact)
			{
				// инициализируем числовое значение
				this.numberValue = Numeral(this.clearFormatValue(value)).value()

				// проверка значения
				if (isNaN(this.numberValue)) this.numberValue = null
				if (this.numberValue !== null && this.numberValue !== undefined)
				{
					// установим значение
					this.$input.autoNumeric('set', this.numberValue)
				}
			}
		}
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>



// WEBPACK FOOTER //
// number.vue?875971d0